<mat-toolbar color="accent">
  <mat-icon class="mr-2">assignment_ind</mat-icon>
  <span>Patient Signature</span>
</mat-toolbar>

<div class="p-6">
  <p class="mb-4 opacity-90">
    Please sign below by either typing your full name or drawing your signature.
  </p>

  <form [formGroup]="form">
    <mat-form-field class="w-full">
      <mat-label>Patient or Guardian's Full Name</mat-label>
      <input
        matInput
        formControlName="typedSignature"
        (input)="form.controls.drawnSignature.reset()"
      />
      <mat-hint>e.g., Jane Citizen</mat-hint>
    </mat-form-field>

    <div class="my-4 flex items-center text-center">
      <div class="grow border-t border-gray-300"></div>
      <span class="mx-4 shrink font-semibold text-gray-500">OR</span>
      <div class="grow border-t border-gray-300"></div>
    </div>

    <div class="flex w-full flex-col items-center">
      <div class="mb-2">Draw your signature in the box below</div>
      <pt-signature-input
        formControlName="drawnSignature"
        label=""
        hint=""
        (signatureChange)="form.controls.typedSignature.reset()"
      />
    </div>

    <div class="mt-8 text-xs">
      <mat-checkbox formControlName="consentGiven" color="primary">
        By checking this box and providing my signature above, I confirm that
        all information on this form is true and correct. I consent to signing
        this document electronically and understand that my electronic signature
        is the legal equivalent of my handwritten signature for all purposes.
      </mat-checkbox>
    </div>

    @if (showConsentError()) {
      <mat-error class="mt-2">
        You must provide consent by checking the box above.
      </mat-error>
    }

    @if (form.hasError('requireOneSignature') && form.touched) {
      <mat-error class="mt-2">
        A signature is required. Please either type or draw your signature.
      </mat-error>
    }
  </form>

  <pt-buttons-container>
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" (click)="submit()">
      Confirm & Sign
    </button>
  </pt-buttons-container>
</div>
